import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { gql, useSubscription } from "@apollo/client";
import { getEmailConfiguration } from "api/emailConfigGenerator.api";

const OUTREACH_EMAIL_SUBSCRIPTION = gql`
  subscription OutreachEmail(
    $token: String!
    $profileId: Int
    $config: Graphene_SearchConfig
    $configId: Int
    $formatResult: Boolean
    $template: Graphene_EmailTemplate
    $externalCompany: String
  ) {
    emailOutreach(
      token: $token
      profileId: $profileId
      config: $config
      configId: $configId
      formatResult: $formatResult
      template: $template
      externalCompany: $externalCompany
    ) {
      text
      timeTaken
      error
      finished
      subject
    }
  }
`;



interface EmailGeneratorProps {
  onEmailUpdate: (email: string) => void;
  onSubjectUpdate: (subject: string) => void;
  profileData: any;
  roleData: any;
  onComplete: (id: string, subject: string, body: string) => void;
  onLoading: (loading: boolean) => void;
  templateData: any;
  externalCompany: string;
}

const EmailGenerator: React.FC<EmailGeneratorProps> = ({
  onEmailUpdate,
  onSubjectUpdate,
  profileData,
  roleData,
  onComplete,
  onLoading,
  templateData,
  externalCompany,
}: EmailGeneratorProps) => {
  const [searchParams] = useSearchParams();
  const search_id = searchParams.get("search_id");
  const [subject, setSubject] = useState<string>("");
  const [emailBody, setEmailBody] = useState<string>("");

  const getConfig = () => {
    return getEmailConfiguration(
      profileData,
      search_id,
      roleData,
      templateData,
      externalCompany,
      26966498
    );
  };

  const { data, loading, error } = useSubscription(
    OUTREACH_EMAIL_SUBSCRIPTION,
    {
      variables: getConfig(),
      shouldResubscribe: true,
      onSubscriptionData: ({ subscriptionData }) => {
        if (subscriptionData?.data?.emailOutreach?.text) {
          const { text, subject } = subscriptionData.data.emailOutreach;
          onSubjectUpdate(subject);
          onEmailUpdate(text);
          setSubject(subject);
          setEmailBody(text);
        }
      },
      onComplete: () => {
        onComplete(profileData.id, subject, emailBody);
      },
    }
  );

  useEffect(() => {
    onLoading(loading);
  }, [loading, onLoading]);

  useEffect(() => {
    if (error) {
      console.error("Subscription error:", error);
    }
  }, [error]);

  return <></>;
};

export default EmailGenerator;
